export const amdinManagerClassManagerCombine = [
  {
    title: "نام ",
    keyName: "fullname",
    key: "client",
  },
  {
    title: "شماره ",
    keyName: "mobile",
    key: "client",
  },
  {
    title: "کدملی ",
    keyName: "national_code",
    key: "client",
  },
  {
    title: "شماره پیگیری",
    key: "trackingcodeorder",
  },
  {
    title: "مبلغ",
    key: "growth_price",
    type: "unit",
  },
  {
    title: "نوع پرداخت",
    key: "type_payment",
    type: "enum",
    enum: {
      gateway: "پرداخت آنلاین",
      wallet: "کیف پول",
      wallet_refund: "واریز به کیف پول",
      others: "پرداخت در محل",
    },
  },
  {
    title: "نوع سفارش",
    key: "model_order",
    type: "enum",
    enum: {
      plans: "برنامه از مربي",
      reserve: "رزرو از مجموعه",
      refund_reserve_wage: "کارمزد بانکی",
      refund_reserve: "کسری استرداد",
      reject_reserve: "بازگشت به کیف پول",
      walletsharge: "افزايش اعتبار",
      joinclass: "ثبت نام در کلاس",
      contractual_reservation: "رزرو قراردادی",
      contractual_reservation_installments: " رزرو قراردادی باز پرداخت بازه ای",
    },
  },
  {
    title: "وضعیت",
    key: "status",
    type: "enum",
    enum: {
      peyed: "موفق",
      waittopay: "در انتظار پرداخت",
      null: "مشکل پرداخت",
      payerror: "ناموفق",
      used: "منقضی شده",
      canceled: "لغو",
      refund: "استرداد",
    },
  },
  {
    title: "تاریخ",
    key: "created_at",
    type: "date",
    timetype: "date-time",
  },
];

export const itemFinancialUserList = [
  {
    title: "نام مشتری ",
    key: "fullname",
  },
  {
    title: "شماره تماس ",
    key: "phone",
  },
  {
    title: "تاریخ سفارش",
    key: "order_date",
    type: "date",
    timetype: "date-time",
  },
  {
    title: "کد پیگیری",
    key: "tracking_code",
  },
  {
    title: "عنوان شیفت",
    key: "title",
  },
  {
    title: "تعداد",
    keys: [{ text: "ب : ", key: "count" }, { text: "خ : ", key: "childCount" }],
    keysClass: "d-flex justify-content-center mb-1",
    multiVal: true
  },
  {
    title: "قیمت واحد",
    type: "unit",
    keys: [{ text: "ب : ", key: "price" }, { text: "خ : ", key: "childPrice" }, { text: "ت : ", key: "ballPrice" }],
    keysClass: "d-flex justify-content-center mb-1",
    multiVal: true
  },
  {
    title: "بستانکار",
    key: "bestankar",
    type: "unit",
  },
  {
    title: "بدهکار",
    key: "bedehkar",
    type: "unit",
  },
  {
    title: "مانده",
    key: "mande",
    type: "unit",
  },
  {
    title: "وضعیت",
    key: "status_fa",
  }
];
